/* eslint-disable */
import { useMemo } from 'react';
import Button from 'epn-ui/umd/dist/components/Button';
import Select from 'epn-ui/umd/dist/components/Select';
import { IGetOffersCompilationsDataFormatted, IGetPlacementsDataFormatted } from '@api/types';
import useI18n from '@i18n';
import useRefreshToken from '@hooks/useRefreshToken';
import OrdInfo from '../OrdInfo';
import OfferButtonGroup from '../../Offer/OfferButtonGroup';
import BaseEmpty from '@components/base/BaseEmpty';
import { IUniqPlacementOption } from '../interfaces';
export interface IOfferInfoProps {
    image: string;
    link: string;
    name: string;
    percent: string;
    compilationIds: number[];
    compilations: IGetOffersCompilationsDataFormatted[];
    offerId: number;
    ordClientFullName: string;
    ordClientInn: string;
    connection: {
        id?: string;
        offerId?: string;
        status?: 'allow' | 'ban' | 'review' | 'recheck' | 'waiting' | null;
        comment?: string | null;
    };
    placementUniqOptions: IUniqPlacementOption[];
    currentPlacement: IGetPlacementsDataFormatted;
    onConnect: () => void;
    onAuth: () => void;
    onShowReason: () => void;
    onChangePlacement: (value: string) => void;
}

const OfferInfo: React.FC<IOfferInfoProps> = ({
    image,
    link,
    name,
    percent,
    compilationIds,
    compilations,
    ordClientFullName,
    ordClientInn,
    offerId,
    connection,
    placementUniqOptions,
    currentPlacement,
    onChangePlacement,
    onConnect,
    onAuth,
    onShowReason,
}) => {
    const { t } = useI18n('Offers');
    const isAuth = useRefreshToken();

    const firstCompilations = useMemo(() => compilationIds?.slice(0, 4), [compilationIds]);
    const compilationsData = useMemo(
        () => compilations.filter(compilation => firstCompilations?.includes(compilation.id)),
        [compilations, firstCompilations],
    );

    return (
        <div className="flex flex-col lg:flex-col items-center sm:justify-between bg-white rounded-[6px] p-[16px] sm:gap-x-4">
            <img src={image} alt="logo" className="max-w-[138px] sm:pb-3 md:pt-3 md:pb-2" />
            <a
                className="text-blueGray-300 text-[12px] max-w-[230px] text-ellipsis"
                href={link}
                target="_blank"
                rel="noopener noreferrer"
            >
                {link}
            </a>

            <h1 className="w-full mt-3 sm:mt-4 font-medium text-blueGray-800 text-[16px] md:text-[18px] leading-[24px] md:leading-[27px]">
                {t('affiliate program — earn up to from an order', {
                    name,
                    percent,
                })}
            </h1>
            <div className="w-full flex flex-wrap mt-3 gap-2">
                {compilationsData.map(compilation => (
                    <span
                        className="font-normal h-[26px] text-[12px] text-blueGray-600 rounded-[6px] px-[8px] py-[4px]"
                        style={{
                            backgroundColor: compilation?.styles?.compilationColor || '#FEFCE8',
                        }}
                    >
                        {compilation?.name}
                    </span>
                ))}
            </div>

            <div className="w-full mt-4 md:mt-5 lg:hidden">
                <OrdInfo
                    ordClientFullName={ordClientFullName}
                    ordClientInn={ordClientInn}
                />
            </div>

            <div className="sm:flex mt-4 gap-4 w-full lg:flex-col lg:gap-2">
                {isAuth && (
                    <Select
                        id="PlacementSelect"
                        className="w-full sm:calc(50% - 4px) lg:w-full"
                        value={currentPlacement?.id}
                        onChange={onChangePlacement}
                        options={placementUniqOptions}
                        placeholder={t('Select placement')}
                        notFoundContent={<BaseEmpty />}
                    />
                )}

                <div className="w-full sm:-mt-4">
                    {isAuth ? (
                        <div className="mt-0 sm:calc(50% - 4px) lg:w-full">
                            <OfferButtonGroup
                                offerId={offerId}
                                onConnect={onConnect}
                                showTheReason={onShowReason}
                                connection={connection}
                                isAuth={isAuth}
                            />
                        </div>
                    ) : (
                        <Button
                            className="!bg-blueGray-800 hover:!bg-blueGray-600 w-full mt-0 sm:mt-4"
                            type="primary"
                            onClick={onAuth}
                        >
                            {t('Get started')}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OfferInfo;
